export const KOUTO_EMBED_ROOT = 'kouto-embed-root';
export const BASE_URL = process.env.KOUTO_API_URL;

/**
 * The catalogs service on the Way platform (AWS), a separate host from the Kouto API. Baked into
 * the bundle at build time like KOUTO_API_URL: the deploy reads it per environment from
 * cicd/environments.json (`aws_api_url`); local dev sets it in .env. It is the AWS api-plane
 * host, shared by the catalogs service and the Kouto adapter.
 */
// Must stay as direct member access: webpack's DefinePlugin/dotenv-webpack only substitute the
// literal `process.env.AWS_API_URL` expression; destructuring `process.env` yields undefined.
// eslint-disable-next-line prefer-destructuring
export const AWS_API_URL = process.env.AWS_API_URL;
export const LAST_CLICKED_LISTING_SESSION_STORAGE_KEY =
  'kouto-last-clicked-listing';
export const TAB_SWAP_SESSION_STORAGE_KEY = 'kouto-tab-swap';
